



export const colors = {
  bg: '#05080f',
  cyan: '#38c8d4',
  red: '#e03434',
  green: '#4ade80',

  ink: '#f0f4f8',
  textSoft: '#aabbc8',
  muted: '#8899aa',
  muted2: '#5a6a7a',

  cardBg: 'rgba(13, 21, 38, 0.8)',
  inputBg: 'rgba(8, 12, 20, 0.8)',

  hairline: 'rgba(255, 255, 255, 0.07)',
  inputBorder: 'rgba(255, 255, 255, 0.1)',
  checkboxBorder: 'rgba(255, 255, 255, 0.2)',
  cyanBorder: 'rgba(56, 200, 212, 0.18)',
  cyanBorderSoft: 'rgba(56, 200, 212, 0.12)',
  cyanFill: 'rgba(56, 200, 212, 0.05)',
  redBorder: 'rgba(224, 52, 52, 0.3)',
  placeholder: 'rgba(240, 244, 248, 0.5)',
};

export const fonts = {
  condensed: "'Barlow Condensed', 'Inter', sans-serif",
  body: "'Barlow', 'Inter', sans-serif",
  mono: "'JetBrains Mono', monospace",
};


export const cardShadow =
  '0px 0px 0px 0px rgba(56, 200, 212, 0.06), 0px 32px 80px 0px rgba(0, 0, 0, 0.65)';
